// extracted by mini-css-extract-plugin
export default {"bannerBack":"home_bannerBack__xImTR"};